import {FC} from 'react'
import {useDispatch} from 'react-redux'
import {useChatRequestsTotalCount} from 'entities/activity'
import {setChatRequestsHide, useChatRequestsHide} from 'entities/app'
import {ChatRequestsList} from 'features/chatRequestsList'
import styles from './styles.module.scss'

type ChatRequestsProps = {
  className?: string
}

export const ChatRequests: FC<ChatRequestsProps> = ({className}) => {
  const dispatch = useDispatch()
  const isHide = useChatRequestsHide()
  const totalCount = useChatRequestsTotalCount()

  return (
    <div className={`${className} ${styles.container} ${isHide ? styles.hide : ''}`}>
      <div className={styles.header}>
        <div>
          <span className={styles.titleText}>Chat Requests</span>
          <span className={styles.countText}>{totalCount}</span>
        </div>
        <div className={styles.hideButton} onClick={() => dispatch(setChatRequestsHide(!isHide))}>
          {isHide ? 'SHOW' : 'HIDE'}
        </div>
      </div>
      <ChatRequestsList />
    </div>
  )
}
